var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        {
          attrs: {
            label: "Supplier identity",
            "label-for": _vm.id("supplier"),
            description:
              "Optional exact Emerald ID. Names and addresses do not merge records.",
          },
        },
        [
          _c("b-form-input", {
            attrs: {
              id: _vm.id("supplier"),
              value: _vm.value.source_record_id,
              maxlength: "64",
            },
            on: {
              input: function ($event) {
                return _vm.update("source_record_id", $event)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        _vm._l(_vm.primaryFields, function (field) {
          return _c(
            "b-form-group",
            {
              key: field,
              staticClass: "col-sm-6",
              attrs: { label: _vm.label(field), "label-for": _vm.id(field) },
            },
            [
              _c("b-form-input", {
                attrs: { id: _vm.id(field), value: _vm.value.fields[field] },
                on: {
                  input: function ($event) {
                    return _vm.fieldValue(field, $event)
                  },
                },
              }),
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _vm.value.type !== "contact"
        ? _c("details", { staticClass: "mb-3" }, [
            _c("summary", [
              _vm._v(
                _vm._s(
                  _vm.value.type === "company"
                    ? "Establishment address"
                    : "Physical address"
                )
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row mt-2" },
              _vm._l(_vm.addressFields, function (field) {
                return _c(
                  "b-form-group",
                  {
                    key: field,
                    staticClass: "col-sm-6",
                    attrs: {
                      label: _vm.label(field),
                      "label-for": _vm.id(field),
                    },
                  },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: _vm.id(field),
                        value: _vm.value.fields[field],
                        maxlength: field === "state" ? 2 : null,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.fieldValue(field, $event)
                        },
                      },
                    }),
                  ],
                  1
                )
              }),
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "details",
        { staticClass: "mb-3" },
        [
          _c("summary", [_vm._v("Contact details")]),
          _vm._v(" "),
          _vm.value.type !== "contact"
            ? _vm._l(["emails", "phones"], function (field) {
                return _c(
                  "fieldset",
                  { key: field, staticClass: "mt-2" },
                  [
                    _c("legend", { staticClass: "h6" }, [
                      _vm._v(_vm._s(_vm.label(field))),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.channels(field), function (row, index) {
                      return _c(
                        "div",
                        { key: row.id, staticClass: "d-flex mb-2" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "sr-only",
                              attrs: { for: _vm.id(`${field}-${index}`) },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.label(field)) +
                                  " " +
                                  _vm._s(index + 1)
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: {
                              id: _vm.id(`${field}-${index}`),
                              value: row.value,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.channelValue(field, row, $event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-btn",
                            {
                              attrs: {
                                type: "button",
                                size: "sm",
                                variant: "link",
                                "aria-label": `Remove ${field} ${index + 1}`,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.removeChannel(field, row)
                                },
                              },
                            },
                            [_vm._v("Remove")]
                          ),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "b-btn",
                      {
                        attrs: {
                          type: "button",
                          size: "sm",
                          variant: "outline-secondary",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.addChannel(field)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "Add " +
                            _vm._s(field === "emails" ? "email" : "phone")
                        ),
                      ]
                    ),
                  ],
                  2
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.contactFields, function (field) {
            return _c(
              "b-form-group",
              {
                key: field,
                staticClass: "mt-2",
                attrs: { label: _vm.label(field), "label-for": _vm.id(field) },
              },
              [
                _c("b-form-input", {
                  attrs: { id: _vm.id(field), value: _vm.value.fields[field] },
                  on: {
                    input: function ($event) {
                      return _vm.fieldValue(field, $event)
                    },
                  },
                }),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c("p", { staticClass: "small text-muted" }, [
        _vm._v(
          "Imports for this record replace initial details. Later corrections stay."
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }